function IcoMapPin() {
    return (
        <svg width="10" height="15" viewBox="0 0 10 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1188_27)">
            <path d="M1.22555 1.78976C2.16892 0.653806 3.54888 0 4.97987 0C6.27794 0 7.54291 0.534121 8.47831 1.48399C12.6239 5.69449 7.19418 11.0604 5.2706 14.8388C5.15909 15.058 4.8136 15.0501 4.69088 14.8378C3.19194 12.2467 0.162446 8.72835 0.00687695 5.37507C-0.0503731 4.13937 0.282421 2.92625 1.22604 1.79003L1.22555 1.78976ZM4.99978 8.01444C6.42878 8.01444 7.58746 6.79291 7.58746 5.28583C7.58746 3.77874 6.42903 2.55722 4.99978 2.55722C3.57054 2.55722 2.4121 3.77874 2.4121 5.28583C2.4121 6.79291 3.57054 8.01444 4.99978 8.01444Z" fill="currentColor"/>
        </g>
        <defs>
            <clipPath id="clip0_1188_27">
                <rect width="10" height="15" fill="white" transform="matrix(-1 0 0 1 10 0)"/>
            </clipPath>
        </defs>
        </svg>

    );
}

export default IcoMapPin;